import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, withModifiers as _withModifiers, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4fa0c8b5"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 2,
  class: "popup"
}
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-text" }
const _hoisted_4 = { class: "popup-title" }
const _hoisted_5 = { class: "centered-container" }
const _hoisted_6 = { class: "custom-list" }
const _hoisted_7 = { class: "custom-item" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_manual_transfer_popup = _resolveComponent("manual-transfer-popup")!
  const _component_ManualTransferConfirmPopup = _resolveComponent("ManualTransferConfirmPopup")!
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_ctx.isShowFinalPopup)
    ? (_openBlock(), _createBlock(_component_manual_transfer_popup, {
        key: 0,
        paymentDTO: _ctx.paymentDto,
        "onUpdate:paymentDTO": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.paymentDto) = $event)),
        _orderId: _ctx.orderId,
        "onUpdate:_orderId": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.orderId) = $event)),
        _vehiclesId: _ctx.vehiclesId,
        "onUpdate:_vehiclesId": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.vehiclesId) = $event)),
        onClose: _ctx.closePopup
      }, null, 8, ["paymentDTO", "_orderId", "_vehiclesId", "onClose"]))
    : (_ctx.isShowConfirmPopup)
      ? (_openBlock(), _createBlock(_component_ManualTransferConfirmPopup, {
          key: 1,
          onClose: _ctx.closePopup,
          onBack: _ctx.goBack,
          onConfirm: _ctx.confirm
        }, null, 8, ["onClose", "onBack", "onConfirm"]))
      : (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("img", {
              src: "/img/close-btn.svg",
              class: "modal__close",
              onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
            }),
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createVNode(_component_i18n_t, { keypath: "payment.paymentPopup.title" })
              ])
            ]),
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("a", {
                href: "",
                onClick: _cache[4] || (_cache[4] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.selectManual && _ctx.selectManual(...args)), ["prevent"])),
                class: "centered-link"
              }, [
                _createVNode(_component_i18n_t, { keypath: "payment.paymentPopup.manualTransfer" })
              ])
            ]),
            _createElementVNode("ul", _hoisted_6, [
              _createElementVNode("li", _hoisted_7, [
                _createVNode(_component_i18n_t, { keypath: "payment.paymentPopup.attention" })
              ])
            ])
          ])
        ]))
}